import imageCompression  from 'browser-image-compression';
//MATERIAL ICONS
import DownloadIcon      from '@mui/icons-material/Download';

// COMPRESS FILE
export async function canCompress(file,setOption,filedata){
	if(file.type){
		let fileTypes = ['image/jpeg','image/jpg','image/png'];
		if(fileTypes.includes(file.type)){
			let option = {
				maxSizeMB : (file.size/1024/1024)>10?2:1
			};
			if(setOption){
				option = { ...option,...setOption };
			}
			return filedata(await imageCompression(file, option));
		}else{
			return filedata(file);
		}
	}
}

// CONVERTING FILE TO BASE 64 FORMAT
export async function readFile(selectedFile,fileType,setOption) {
	return await canCompress(selectedFile,setOption, async(file)=>{
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.onload = () => {
				// var fileRslt = fileReader.result;
    
				let fileRslt = fileReader.result.split(/base64,/)[1];
				let type      = file.type;
				if(fileType){
					type = fileType;
				}
				resolve({ sts:true,msg:'file read success',fileName:file.name,size:file.size,type:type,body:fileRslt });
			};
			fileReader.onerror = () => {
				reject({ sts:false,msg:'file read failed',fileName:'',size:'',type:'',body:'' });
			};
			fileReader.readAsDataURL(file);
		});
	});
}

// IF IMAGE DOES NOT EXIST WILL RETURN NULL
export function imageExist(proData) {
	let required   = proData.required;
	let url        = proData.url;
	let alt        = proData.alt;
	// var size       = proData.size;
	let width      = proData.size?proData.size:proData.width;
	let height     = proData.size?proData.size:proData.height;
	let altImg     = proData.altImg;
	// var mode       = proData.mode;
	let style      = proData.style;
	let imageInfo = null;
	let className = proData.className?proData.className:'custom_img';
	let imgUrl = '';
   
	/* eslint-disable no-undef */
	imgUrl = require(`../../assets/img${required+url}`);
	/* eslint-enable no-undef */
     
	if((required)&&(url)){
		try {
			// imageInfo = <img src={require(`../../assests/images${required+url}`).default} alt={alt} className={className} width={size} height={size}/>
			imageInfo = <img src={imgUrl} onClick={proData.onClick} alt={alt} className={className} width={width} height={height} style={style}/>;
		}catch(e) {
			imageInfo = altImg?altImg:null;
		}
	}else{
		imageInfo = null;
	}
	return imageInfo;
}


export function fileExist(proData) {
	let required   = proData.required;
	let url        = proData.url;
	let altImg     = proData.altImg;
	let style      = proData.style;
	let name       = proData.name;
	let imageInfo = null;
	let className = proData.className?proData.className:'custom_img';
	let fileUrl = '';
	let label    = proData.label ? proData.label : '';
	/* eslint-disable no-undef */
	fileUrl = require(`../../assets/pdf${required+url}`);
	/* eslint-enable no-undef */
    
	if((required)&&(url)){
		try {
			imageInfo = <a download={name} href={fileUrl} className={className} style={style}> 
				{label === 'Download' ? <DownloadIcon sx={{ transform:'translate(0px,3px)' }}/> : '' } {label}
			</a>;
		}catch(e) {
			imageInfo = altImg?altImg:null;
		}
	}else{
		imageInfo = null;
	}
	return imageInfo;
}
